import { Link } from 'react-router-dom'
import { rag_gif } from '../../../assets'
import '../Project.css'

export default function RAG() {

  window.scrollTo(0, 0)
  
  return (
    <>
      <div className='project-wrapper'>
        <div className="project-container">
          <div className='project-image-container'>
            <img src={rag_gif} className='project-image'
              alt='RAG Chatbot' />
          </div>
          <div className='project-title'>
            <h1>J.A.R.V.I.S.</h1>
          </div>
          <div className='project-description'>
            <p>This RAG chatbot uses the Chainlit and LangChain Python libraries in conjunction with the Llama2-7B-Chat model to answer a user's prompts after being provided with a PDF file for referencing. In this example, the bot will answer questions using the owner's manual for a motorcycle.</p>
          </div>
          <div className='project-links'>
            <Link to='https://github.com/OwenJRJones/Llama2RAG'
              target='_blank'
              rel='noreferrer'
            >
              <i className='fab fa-github' >&nbsp;</i>
              GitHub
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
